module.exports = __webpack_public_path__ + "img/google.648fa9fa.svg";